"use client";

import { Suspense } from "react";
import { useAnalytics } from "@/hooks/use-analytics";

function PageViewTrackerInner() {
  useAnalytics({ trackPageViews: true });
  return null;
}

/** Mount once near the root to record SPA page views. */
export function PageViewTracker() {
  return (
    <Suspense fallback={null}>
      <PageViewTrackerInner />
    </Suspense>
  );
}
